var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("toggle-details", {
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function (ref) {
            var opened = ref.opened
            var toggle = ref.toggle
            var isMounted = ref.isMounted
            return _c("div", { staticClass: "see-details" }, [
              _c(
                "div",
                { staticClass: "main-content" },
                [
                  _vm._t("default", null, null, {
                    opened: opened,
                    toggle: toggle,
                    isMounted: isMounted,
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "detailed-content",
                  class: [{ opened: opened }],
                },
                [
                  _c(
                    "transition",
                    { attrs: { name: "expand-y" } },
                    [opened ? _vm._t("details") : _vm._e()],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "activator" }, [
                    _c(
                      "button",
                      {
                        attrs: {
                          "aria-label": "Toggle details",
                          "aria-expanded": opened ? "true" : "false",
                        },
                        on: {
                          click: toggle,
                          enter: toggle,
                          space: function ($event) {
                            $event.preventDefault()
                            return toggle($event)
                          },
                        },
                      },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.tc("booking.details")))]),
                        _vm._v(" "),
                        _c("div", {
                          class: opened ? "icon-minus" : "icon-add",
                        }),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ])
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }